import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Typography, DatePicker, Modal, Table, Form, TimePicker, TreeSelect, Row, Col, Input, Tabs, Menu, Badge, Space, Select, Card, Spin } from "antd";
import {
    getDaysArray,
    openNotificationWithIcon,
    capitalizeFirstWord,
    getMinute,
    errorHandle,
    isMatchTwoArray,
    generateArrWeekAndDays
} from "../../Function";
import moment from "moment";
import { useSelector } from "react-redux";
import {
    CloseOutlined, DoubleLeftOutlined, DoubleRightOutlined, SendOutlined, CheckOutlined
} from "@ant-design/icons";
// import ListTeamOfMemberManagerApi from "../../../api/getListTeamOfMemberManage";
import {changeStatusCCApi, chinhSuaChamCongApi, quanLyChiTietCongApi} from "../../../api/getChamcong";
import {lichSuChamCongApi, lichSuChinhSuaApi} from "../../../api/getLichSuChamCong";
import {LichLeTetApi} from "../../../api/getKhaiBao";
import { BsFillSquareFill, BsSquare } from "react-icons/bs"; //npm i react-icons
import ListTeamApi, { ListBoPhanApi } from "../../../api/getListTeam";
import {getDateRange} from "../../Function";

const { Text, Link } = Typography;

// const dataLichSuChamCong = [{ngay:"2022-04-11",time:'09:00',thietbi:"Abc"},{ngay:"2022-04-12",time:'10:00',thietbi:"Abc"},{ngay:"2022-04-12",time:'11:00',thietbi:"Abc"}];
// const dataLichSuChamCong = [];


const { Title } = Typography;

const getHeader = (data,date,isHoliday, currentSelectedDate )=>{
    return <span style={{color:isHoliday ? 'red' : ''}}>{new Date(data).getDay() === 0 ? "CN" : "Thứ " + (new Date(data).getDay() + 1)}<br/>
        {currentSelectedDate.month() == moment(data).month() ?
            moment(data).format('DD/MM/YYYY') : ""
        }
    </span>
}

const getClassColor = (type) =>{
    let result;
    switch (type) {
        case 'Done':
            result = 'timekeeper-undefined';
            break;
        case 'Processing':
            result = 'timekeeper-undefined';
            break;
        case 'Error':
            result = 'timekeeper-error';
            break;
        default:
            result = '';
            break;
        // default: result = date <= new Date() ? 'timekeeper-future' : 'timekeeper-undefined';break;
    }
    return result || '';
}

const RenderItemRow = (text,record,updateData,currentDate,setIsShowDetailItem, setCurrentItem,setCurrentDateSelected)=>{
    return (
        <>
            <div style={{textAlign:'center',width:'100%'}}>
                {text ?
                <RenderSingleInnerItem record={record} text={text} currentDate={currentDate} setIsShowDetailItem={setIsShowDetailItem} setCurrentItem={setCurrentItem} setCurrentDateSelected={setCurrentDateSelected}/>
                :
                "-"}
            </div>
        </>
    )
}

const RenderSingleInnerItem =({record,text,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected})=>{
    const onShowDetailItem =()=>{
        setCurrentDateSelected(currentDate);
        setCurrentItem(record);
        setIsShowDetailItem(true);
    }
    const getText =(text)=>{
        let result
        switch (text.type) {
            case 'Success':
                result = text.soGioCong === 0 ? "-" : text.soGioCong + text.cheDo;break;
            case 'Error':
                result = text.ghiChu;break;
            case 'offDate':
                result = '-';break;
            case 'Processing':
                let convertGioVao = text.gioVao ? text.gioVao.toString().substr(0,5) : "";
                let convertGioRa = text.gioRa ? text.gioRa.toString().substr(0,5) : "";
                result = convertGioVao + " - " + convertGioRa;
                break;
            default:
                result = '';break;
        }
        if (text.loaiChamcongChitiet !== '' && text.loaiChamcongChitiet !== null) {
            result += "(" + text.soGioCD + "h - " + text.loaiChamcongChitiet + ")"
        }

        return result;
    }
    return <>
        <div onClick={text.type !== 'offDate' ? onShowDetailItem : null}>
            {getText(text)}
        </div>

    </>
}

const ModalDetailItem = ({visible,onCancel,itemDetail,currentDate,updateData})=>{
    const [form] = Form.useForm();
    const userInfo = useSelector(state => state.getUserInfo.userInfo)
    const [dataLs, setDataLs] = useState([]);
    const [dataLsCC, setDataLsCC] = useState([]);
    const [activeKey, setActiveKey] = useState('1');
    const [isEditing,setIsEditing] = useState(false);
    const [timeStart, setTimeStart] = useState(itemDetail['col'+currentDate] ? moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm") : null);
    const [timeEnd, setTimeEnd] = useState(itemDetail['col'+currentDate] ? moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm") : null);
    const [lsTeamPer, setLsTeamPer] = useState([]);

    useEffect(()=>{
        if (visible && itemDetail.hasOwnProperty('col'+currentDate)){
            form.setFieldsValue({
                ngay: moment(itemDetail['col'+currentDate].ngay,'YYYY-MM-DD').format('DD/MM/YYYY').toString(),
                gioVao: itemDetail['col'+currentDate].gioVao,
                gioRa: itemDetail['col'+currentDate].gioRa,
                soGioCong: itemDetail['col'+currentDate].soGioCong,
                soCong: itemDetail['col'+currentDate].soCong,
                loaiCC: itemDetail['col'+currentDate].loaiChamCong
            })
        }
        // itemDetail.hasOwnProperty('col'+currentDate) ? setLsDuAn(itemDetail['col'+currentDate].listDuan) : null;

        const arrTeam = userInfo.team_permissions.map((item,index)=>item.phanquyen__ten_pq)
        setLsTeamPer([...new Set(arrTeam)]);
    },[visible])

    const onEditing =()=>{
        setTimeEnd(moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm"))
        setTimeStart(moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm"))
        form.setFieldsValue({
            gioVao: moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioVao,"YYYYMMDDHH:mm"),
            gioRa: moment(moment(new Date()).format("YYYYMMDD") + itemDetail['col'+currentDate].gioRa,"YYYYMMDDHH:mm"),
        })
        setIsEditing(true);
    }

    const getDisableHourOutEdit = () => {
        const timeIn = timeStart ? timeStart._d.getHours() : 0
        let arrCheck = [...Array(24).keys()]
        return arrCheck.filter(item => item < timeIn)
    }

    const getDisableHourInEdit = () => {
        const timeIn = timeEnd ? timeEnd._d.getHours() : 24
        let arrCheck = [...Array(24).keys()]
        return arrCheck.filter(item => item > timeIn)
    }

    const onFinish = (values) => {
        chinhSuaChamCongApi({
            id: itemDetail['col'+currentDate].id,
            gioVaoHT: moment(new Date(values.gioVao._d)).format("HH:mm"),
            gioRaHT: moment(new Date(values.gioRa._d)).format("HH:mm"),
            ghichu: values.note,
        }).then(r=>{
            updateData(); // 201123
            onCancelModal();
            form.resetFields();
            setActiveKey('1')
        })
            .catch(err=>{
                errorHandle(err)
            })

    };

    const onCancelModal =()=>{
        // updateData(); // 201123
        form.resetFields();
        setIsEditing(false);
        setActiveKey('1');
        onCancel();
    }

    const tailLayout = {
        wrapperCol: { offset: 5, span: 15 },
    };

    const viewHistoryEdit = (values) => {
        // Id bảng chấm công cá nhân
        if (itemDetail['col'+currentDate].ghiChu == "Không chấm công"){
            openNotificationWithIcon('error','Lỗi', 'Nhân viên chưa chấm công')
            return false
        }

        lichSuChinhSuaApi({id:itemDetail['col'+currentDate].id}).then(r=>{
            setDataLs(r.data);
            setActiveKey('3');
        })
    };

    const viewHistoryTimekeeping = (values) => {
        // Id của user
        lichSuChamCongApi({
            idUser:itemDetail.id,
            tuNgay: itemDetail['col'+currentDate].ngay,
            denNgay: itemDetail['col'+currentDate].ngay
        }).then(r=>{

            setDataLsCC(r.data);
            setActiveKey('2');
        })
    };

    const FormViewHistoryEdit = ({itemDetail})=>{
        const [loadingLs, setLoadingLs] = useState(false);
        const [pagerLs, setPagerLs] = useState({pageSize:10});

        const columns = [
            {
                title: "STT",
                dataIndex: "index",
                key: "index",
                align: 'center',
                render: (value, item, index) => ((pagerLs.current || 1) - 1) * pagerLs.pageSize + index + 1,
            },
            {
                title: "Người điều chỉnh",
                dataIndex: "userEditName",
                key: "userEditName",
                type: 'text',
                align: 'center'
            },
            {
                title: "Thời gian cập nhật",
                dataIndex: "created",
                key: "created",
                type: 'text',
                align: 'center',
                render:(text,record)=> moment(new Date(text)).format("DD/MM/YYYY HH:mm")

            },
            {
                title: "Giờ vào",
                type: 'text',
                align: 'center',
                children : [
                    {
                        title: 'Cũ',
                        dataIndex: 'gioVaoOld',
                        key: 'gioVaoOld',
                        // render:(text,record) => record.gioVao[0]
                    },
                    {
                        title: 'Mới',
                        dataIndex: 'gioVaoNew',
                        key: 'gioVaoNew',
                        render:(text,record)=> text != "" ? (record.gioVaoNew != record.gioVaoOld ? <span style={{color: "red"}}>{text}</span> : text): ''
                        // render:(text,record)=> record.gioVao[1] != "" ? <span style={{color: "red"}}>{record.gioVao[1]}</span> : record.gioVao[0]
                    },
                ]
            },
            {
                title: "Giờ ra",
                align: 'center',
                children : [
                    {
                        title: 'Cũ',
                        dataIndex: 'gioRaOld',
                        key: 'gioRaOld',
                        // render:(text,record)=> record.gioRa[0]
                    },
                    {
                        title: 'Mới',
                        dataIndex: 'gioRaNew',
                        key: 'gioRaNew',
                        render:(text,record)=> text != "" ? (record.gioRaNew != record.gioRaOld ? <span style={{color: "red"}}>{text}</span> : text): ''
                        // render:(text,record)=> record.gioRa[1] != "" ? <span style={{color: "red"}}>{record.gioRa[1]}</span> : record.gioRa[0]
                    },
                ]
            },
            {
                title: "Ghi chú",
                dataIndex: "ghichu",
                key: "ghichu",
                align: 'center'
            },
        ]

        return (
                <Table
                    dataSource={itemDetail}
                    columns={columns}
                    loading={loadingLs}
                    bordered={true}
                    scroll={{y:500}}
                    size={'small'}
                    rowKey="id"
                    // onChange={handleChange}
                    pagination={false}

                />
        )
    }

    const FormViewHisTimekeeping  = ({itemDetail})=>{
        const [pagerLsCC, setPagerLsCC] = useState({pageSize:10, current:1});
        const columnsTimeKeeping = [
            {
                title: "STT",
                dataIndex: "index",
                key: "index",
                align: 'center',
                render: (value, item, index) => ((pagerLsCC.current || 1) - 1) * pagerLsCC.pageSize + index + 1,
            },
            // {
            //     title: "Ngày",
            //     dataIndex: "ngayChamcong",
            //     key: "ngayChamcong",
            //     align: 'center',
            //     render: (text)=> moment(new Date(text)).format("DD/MM/YYYY"),
            // },
            {
                title: "Giờ",
                dataIndex: "gioChamcong",
                key: "gioChamcong",
                align: 'center'
            },
            {
                title: "Thiết bị",
                dataIndex: "thietbiChamcong",
                key: "thietbiChamcong",
                align: 'center'
            },
            {
                title: "Vị trí thiết bị",
                dataIndex: "vitriThietbi",
                key: "vitriThietbi",
                align: 'center'
            },

        ]

        return (

            <Table
                dataSource={itemDetail}
                // @ts-ignore
                columns={columnsTimeKeeping}
                bordered={true}
                // scroll={{x:1200}}
                size={'small'}
                rowKey="id"/>
        )
    }

    return <Modal visible={visible} onCancel={onCancelModal}
            title={<>Chi tiết công - {itemDetail.hasOwnProperty('nhanvien') ? itemDetail.nhanvien.toString() : ''} - {itemDetail.hasOwnProperty('col'+currentDate) && capitalizeFirstWord(moment(itemDetail['col'+currentDate].ngay, 'YYYY-MM-DD').format('dddd, [ngày] DD/MM/YYYY')) }</>}
            style={{minWidth: "700px"}}
                  width={1000}
            footer={false}
            className={itemDetail.hasOwnProperty('col'+currentDate) ? `${getClassColor(itemDetail['col'+currentDate].type)}-modal` : ""}
            bodyStyle={{paddingTop: 6}}
            >
                <Tabs
                    activeKey={activeKey}
                    type="card"
                    tabBarStyle={{display:"none"}}
                >

                    <Tabs.TabPane
                        tab={''}
                        key="1"
                    >
                        <Form form={form} name="control-hooks" onFinish={onFinish} layout={'vertical'}>
                            <Row justify="center">
                                <Col span={11}>
                                    <Form.Item name="gioVao" label="Giờ vào" style={{marginBottom: 6}}>
                                        {isEditing ? <TimePicker
                                            format="HH:mm"
                                            placeholder={"-"}
                                            // inputReadOnly={true}
                                            allowClear={false}
                                            value={timeStart}
                                            onSelect={(value)=>{setTimeStart(value);form.setFieldsValue({gioVao:value})}}
                                            disabledHours={getDisableHourInEdit}
                                        />:
                                        <Input disabled/>}
                                    </Form.Item>
                                </Col>
                                <Col span={11} offset={2}>
                                        <Form.Item name="gioRa" label="Giờ ra" style={{marginBottom: 6}}>
                                        {isEditing ? <TimePicker
                                            format="HH:mm"
                                            placeholder={"-"}
                                            // inputReadOnly={true}
                                            value={timeEnd}
                                            allowClear={false}
                                            onSelect={(value)=>{setTimeEnd(value);form.setFieldsValue({gioRa:value})}}
                                            disabledHours={getDisableHourOutEdit}
                                        />:
                                        <Input disabled/>}
                                    </Form.Item>
                                </Col>

                            </Row>

                            <Row justify="center">
                                <Col span={11}>
                                    <Form.Item name="soGioCong" label="Số giờ công" style={{marginBottom: 6}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>
                                <Col span={11} offset={2}>
                                    <Form.Item name="soCong" label="Số công" style={{marginBottom: 6}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row >
                                <Col span={11}>
                                    <Form.Item name="loaiCC" label="Loại chấm công" style={{marginBottom: 0}}>
                                        <Input disabled bordered={false}/>
                                    </Form.Item>
                                </Col>


                                {itemDetail['col' + currentDate] && itemDetail['col' + currentDate].id !== '' && [1,4,6].includes(itemDetail['col' + currentDate].statusId)
                                    && userInfo && lsTeamPer.includes('detailed_timesheet_edit') && isEditing ?
                                    <Col span={11} offset={2}>
                                        <Form.Item
                                            label="Ghi chú"
                                            name="note"
                                            rules={[{ required: true }]}
                                            style={{marginBottom: 6}}
                                        >
                                            <Input maxLength={300}/>
                                        </Form.Item>
                                        </Col>
                                    : null}

                            </Row>
                            <Row >
                                <Col span={5} >
                                    <Menu
                                        mode="vertical"
                                        expandIcon={<DoubleRightOutlined className="text-link"/>}
                                        style={{borderRight: 0}}
                                        className="text-link"
                                        selectable={false}
                                        >
                                        <Menu.SubMenu
                                            title={<><span className="text-link">Xem lịch sử</span></>}
                                            style={{paddingRight: 0}}
                                        >
                                            <Menu.Item key="1" onClick={viewHistoryTimekeeping}>
                                                <a className="text-link">Chấm công</a>
                                            </Menu.Item>
                                            <Menu.Item key="2" onClick={viewHistoryEdit}>
                                                <a className="text-link">Chỉnh sửa</a>
                                            </Menu.Item>
                                        </Menu.SubMenu>
                                    </Menu>
                                </Col>
                                <Col span={18} className={'mt-3'}>
                                    {itemDetail['col' + currentDate] && itemDetail['col' + currentDate].id !== '' && [1,4,6].includes(itemDetail['col' + currentDate].statusId)
                                    && userInfo && lsTeamPer.includes('detailed_timesheet_edit') ?
                                    (isEditing ?
                                    <>
                                        <Form.Item  wrapperCol = {{offset: 8, span: 15 }} style={{marginBottom: 0}}>
                                            <Button onClick={()=>{form.submit()}} type={'primary'} style={{marginRight: 10}}>Lưu</Button>
                                        </Form.Item>
                                    </>
                                    :
                                        <Form.Item  wrapperCol = {{offset: 8, span: 15 }} style={{marginBottom: 0}}>
                                            <Button onClick={onEditing} type={'primary'} danger style={{marginRight: 10}}>Chỉnh sửa</Button>
                                        </Form.Item>
                                    )
                                    :null}
                                </Col>
                            {/*<Button onClick={onCancel}>Thoát</Button>*/}
                            </Row>
                        </Form>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                        tab={''}
                        key="2"
                    >
                        <Row >
                            <Col span={24} className={'mt-4 mb-4'}>
                                <FormViewHisTimekeeping itemDetail={dataLsCC}></FormViewHisTimekeeping>
                            </Col>
                            <Col span={24} style={{marginBottom: 6}}>
                                <Text italic onClick={()=>setActiveKey('1')} style={{cursor: "pointer"}}><a className="text-link"><DoubleLeftOutlined /> Xem chi tiết công </a></Text>
                            </Col>
                        </Row>
                    </Tabs.TabPane>

                    <Tabs.TabPane
                        tab={''}
                        key="3"
                    >
                        <Row>
                            <Col span={24} className={'mt-4 mb-4'}>
                                <FormViewHistoryEdit itemDetail={dataLs}></FormViewHistoryEdit>
                            </Col>
                            <Col span={24} style={{marginBottom: 6}}>
                                <Text italic onClick={()=>setActiveKey('1')} style={{cursor: "pointer"}}><a className="text-link"><DoubleLeftOutlined /> Xem chi tiết công </a></Text>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>

        </Modal>
}


export const BangChamCongChiTiet =()=>{
    const defaultPageSize = 50;
    const [pager, setPager] = useState({pageSize:defaultPageSize, count: 0, current:1});
    const [data, setData] = useState([]);
    const [lsDate, setLsDate] = useState(getDateRange(moment(new Date())));
    const [statusAll, setStatusAll] = useState([]);
    const [lsTeam, setLsTeam] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [lsMemberId, setLsMemberId] = useState([]);
    const [treeData,setTreeData] = useState([]);
    const [currentTeam, setCurrentTeam] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [currentDateSelected, setCurrentDateSelected] = useState(null);
    const [columns,setColumns] = useState([]);
    const [isShowDetailItem, setIsShowDetailItem] = useState(false);
    const systemGroup = useSelector((state)=>state.systemInfo.systemGroup);
    const [lsIdChamCong, setLsIdChamCong] = useState([]);
    const [isValid, setIsValid] = useState(true);
    // const [dataLichSuEdit, setDataLichSuEdit] = useState(false);
    const [lsBoPhan, setLsBoPhan] = useState([]);
    const [currentBoPhan, setCurrentBoPhan] = useState([]);
    const [treeDataBoPhan,setTreeDataBoPhan] = useState([]);
    const [lsAllTeam, setLsAllTeam] = useState([]);
    const [lsAllWeek, setLsAllWeek] = useState([]);
    const [idCurWeek, setIdCurWeek] = useState(0);
    const [isComboDate, setIsComboDate] = useState(true);
    const [currentWeek, setCurrentWeek] = useState('');
    const [listNgayLe, setListNgayLe] = useState([]);

    const userInfo = useSelector((state)=>state.getUserInfo.userInfo);

    const submitApproval = (type,requirePerm,action) =>{
        let lsTeamNotValid = []
        const arrTeam = lsTeam.filter(item=>currentTeam.includes(item.idTeam))
        if  (requirePerm.length === 1){
            for (const iTeam of arrTeam){
                let isValidPerm = []
                isValidPerm = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === requirePerm[0] && iTeam.idTeam === item.team)
                if (isValidPerm.length === 0){
                    lsTeamNotValid.push(iTeam.team)
                }
            }
            if (lsTeamNotValid.length > 0){
                openNotificationWithIcon('error','Lỗi', 'Bạn không có quyền ' + action + ' với' + (lsTeamNotValid.length > 1 ? ' các' : '') +' team ' + lsTeamNotValid.join(', '))
                return
            }
        }
        else {
            for (const iTeam of arrTeam){
                let arrPerm1 = 0
                let arrPerm2 = 0
               arrPerm1 = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === requirePerm[0] && iTeam.idTeam === item.team).length
               arrPerm2 = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === requirePerm[1] && iTeam.idTeam === item.team).length
                if (arrPerm1 === 0 || arrPerm2 === 0) {
                    lsTeamNotValid.push(iTeam.team)
                }
            }
            if (lsTeamNotValid.length > 0){
                openNotificationWithIcon('error','Lỗi', 'Bạn không có quyền ' + 'Xem xét' + ' với' + (lsTeamNotValid.length > 1 ? ' các' : '') +' team ' + lsTeamNotValid.join(', '))
                return
            }

        }

        if (!isValid) {
            openNotificationWithIcon("error",'Lỗi',"Có dữ liệu không hợp lệ, vui lòng kiểm tra lại");
            return;
        }
        setLoading(true);
        changeStatusCCApi({
            type:type,
            listIdHC :JSON.stringify(lsIdChamCong)
        }).then(res=>{
            updateData();
            setLoading(false);
            openNotificationWithIcon('success','Thành công','');
        })
            .catch(err=>{
                errorHandle(err)
                setLoading(false);
            })
    }

    const GetLsButton = ({permissions,systemGroup,status,lsDate, teamPermissions})=>{
        const maxGroup = new Set(systemGroup.map(item=>item.group)).size
        const BtnGuiPd = ()=> <Button ghost type='success' className={'m-2'} onClick={()=>submitApproval('send_approval',['detailed_timesheet_xx'],'Gửi phê duyệt')} icon={<SendOutlined />} >Gửi phê duyệt</Button>
        const BtnGuiPdAndPd = ()=> <Button ghost type='success' className={'m-2'} onClick={()=>submitApproval('accept_approval',['detailed_timesheet_xx','detailed_timesheet_pd'],'Phê duyệt')} icon={<CheckOutlined />}>Phê duyệt</Button>
        const BtnPd = ()=> <Button ghost type='success' className={'m-2'} onClick={()=>submitApproval('accept_approval',['detailed_timesheet_pd'],'Phê duyệt')} icon={<CheckOutlined />}>Phê duyệt</Button>
        const BtnKhongPd = ()=> <Button ghost type='danger' className={'m-2'} onClick={()=>submitApproval('refuse_approval',['detailed_timesheet_reject'],'Không duyệt')} icon={<CloseOutlined />}>Không duyệt</Button>

         // const arrTeam = teamPermissions.map((item,index)=>item.phanquyen__ten_pq);
        // 270723 Update Phê duyệt/Gưi phê duyệt theo view Team
        const arrTeam = teamPermissions.filter((e)=> currentTeam.includes(e.team) == true).map((item,index)=>item.phanquyen__ten_pq);
        const uniqueArrTeam = [...new Set(arrTeam)];

        let results = []
        // 010323 Nếu ngày cuối tuần của tháng đang chọn >= ngày hiện tại thì ko Duyệt
        if (lsDate.filter(item => moment(currentSelectedDate).month() == moment(item).month()).at(-1) >= new Date()) {
            return results
        }

        // 301024 Check bảng công nếu có >= 2 trạng thái chấm công thì không cho gửi pd / duyệt / ko duyệt
        // 311024 Không dùng TH này
        // const uniqueNumbers = [...new Set(status.filter(item => typeof item === 'number'))];
        // const hasTwoOrMoreUniqueNumbers = uniqueNumbers.length >= 2;
        // if (hasTwoOrMoreUniqueNumbers == true) {
        //     return results
        // }

        switch (maxGroup) {
            case 4:
                if (isMatchTwoArray([1,4,6],status)){ // Xem xét, NPD ko duyệt, HR ko duyệt
                    if ((uniqueArrTeam.includes('detailed_timesheet_xx') && uniqueArrTeam.includes('detailed_timesheet_pd'))){
                        results.push(<BtnGuiPdAndPd />)
                    }
                    else {
                        if (uniqueArrTeam.includes('detailed_timesheet_xx')) {
                        results.push(<BtnGuiPd />)}
                    }
                }
                else if (status.includes(2)){
                    if (uniqueArrTeam.includes('detailed_timesheet_pd')) {
                        results.push(<BtnPd />)}
                    if (uniqueArrTeam.includes('detailed_timesheet_reject')) {
                        results.push(<BtnKhongPd />)}
                }
        }
        return results.map((item,index)=><span key={index}>{item}</span>)
    }
    const mapDataBCCDetail =(data)=>{
        let results = [];
        let lsMemberId = [];
        let isValid = true;
        let lsIdCCTemp = [];
        for (let i of data) {
            if (i.data.length === 0){
                continue
            }
            lsMemberId.push(i.id)
            let obj = {};
            obj.id = i.id;
            obj.nhanvien = i.msnv + '-' +i.username;
            obj.team = i.team;
            obj.soNgayCong = i.soNgayCong;
            obj.soGioCong = i.soGioCong;
            obj.status = i.status;
            for (let k of i.data) {
                if (k.type === "Error") {
                    isValid = false
                }
                if (k.id !== '') {
                    lsIdCCTemp.push(k.id);
                }
                obj['col' + moment(k.ngay,"YYYY-MM-DD").format("DDMM")] = k;
            }
            results.push(obj);
        }
        setIsValid(isValid)
        setLsIdChamCong(lsIdCCTemp);
        return [results,lsMemberId]
    }

    const getStyleColorOT = (item) =>{
        let result;
        if (item.type === 'Error'){
            result = "#FFCAAF";
        }
        else {
            switch (item.statusId) {
            case 4:
                result = 'red'; //Ngày công có trạng thái “NPD không phê duyệt”
                break;
            case 3:
                result = '#75ef42'; //Ngày công có trạng thái “NPD đã phê duyệt”
                break;
            case 5:
                result = '#31ecd0'; //Ngày công có trạng thái “HR đã phê duyệt”
                break;
            case 6:
                result = '#ec238a'; //Ngày công có trạng thái “HR không phê duyệt”:
                break;
            case 2:
                result = '#4ca4f1'; //Ngày công có trang thái “Chờ NPD phê duyệt”
                break;
            default:
                result = '#ffffff'; //Ngày công có trang thái “Xem xét”, “Chốt công”
                break;
            }
        }

        return result || '';
    }
    const mapColBCCDetail =(data1,listNgayLe)=>{
        let columns_date = [];
        // let ls_date = [];
        // data1.map(({data})=>{
        //     data != [] && data.map((item)=>{
        //         ls_date.push(moment(item.ngay,"YYYY-MM-DD"))
        //     })
        // });
        // const comparisonValues = ls_date.map(v => v.valueOf());
        // ls_date = ls_date.filter((v,i) => comparisonValues.indexOf(v.valueOf()) == i);
        // ls_date.sort((a, b) => a.diff(b));
        // ls_date = ls_date.filter(item => moment(currentSelectedDate).month() == moment(item).month());
        // for (let [i, value] of ls_date.entries()) {
        for (let [i, value] of lsDate.entries()) {
            const isHoliday = listNgayLe.filter(item=>item.ngay === moment(value).format('YYYY-MM-DD')).length > 0
            let columns_detail = {};
            let currentDate = moment(value).format("DDMM");
            columns_detail['title'] =  getHeader(moment(value),lsDate,isHoliday, currentSelectedDate );
            columns_detail['dataIndex'] = 'col' + currentDate;
            columns_detail['key'] = 'col' + currentDate;
            columns_detail['filterKey'] = 'col' + currentDate;
            columns_detail['type'] = 'text';
            columns_detail['className'] = 'hoverBlur';
            columns_detail['align'] = 'center';
            columns_detail['canSearch'] = true;
            // columns_detail['color'] = 'red';
            columns_detail.render = (text,record) => {
                if (moment(currentSelectedDate).month() == moment(value).month()) {
                    return {
                        props: {
                            style:{borderRadius:0,background:record['col' + currentDate] ? getStyleColorOT(record['col' + currentDate]) :"",
                                borderBottom:record['col' + currentDate] && record['col' + currentDate].isEdit ? '2px solid red':''},
                            },
                            children: <div>{RenderItemRow(text,record,updateData,currentDate,setIsShowDetailItem,setCurrentItem,setCurrentDateSelected)}</div>
                    };
                } else {
                    return "";
                }
            };
            columns_date.push(columns_detail);
        }

        const columns_first = [
            // {
            //     title: "STT",
            //     dataIndex: "index",
            //     key: "index",
            //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
            //     sortDirections: ['descend', 'ascend', 'descend'],
            // },
            {
                title: "Nhân viên",
                dataIndex: "nhanvien",
                className:'highlight',
                key: "nhanvien",
                filterKey: 'nhanvien',
                type: 'text',
                canSearch: true,
                fixed:'left'
            },
            {
                title: "Team",
                dataIndex: "team",
                className:'highlight',
                key: "team",
                filterKey: 'team',
                type: 'text',
                canSearch: true
            },
        ]

        const columns_last = [
            {
                title: 'Số giờ công',
                dataIndex: "soGioCong",
                className:'highlight',
                key: "soGioCong",
                filterKey: 'soGioCong',
                align:'center',
                type: 'text',
                canSearch: true,
            },
            {
                title: 'Số ngày công',
                dataIndex: "soNgayCong",
                key: "soNgayCong",
                className:'lastColumn highlight',
                filterKey: 'soNgayCong',
                align:'center',
                type: 'text',
                canSearch: true,
            },
            // {
            //     title: 'Trạng thái',
            //     dataIndex: "status",
            //     key: "status",
            //     filterKey: 'status',
            //     align:'center',
            //     type: 'text',
            //     canSearch: true,
            // },
        ]

        let columns = [...columns_first, ...columns_date, ...columns_last]
        // console.log(columns);

        return columns
    }

    // const fetchNgayLe = async (params = {})=> {
    //      return await LichLeTetApi({...params})
    // }
    useEffect(()=>{
        LichLeTetApi({
            nam: moment(currentSelectedDate).year()
        }).then(r=>{
            setListNgayLe(r.data);
        })
    },[])

    const fetchData = async (params = {})=>{
        setLoading(true);
        setStatusAll([]);
        const lsDateInMonth = params.lsDate.filter(item => moment(currentSelectedDate).month() == moment(item).month());
        // const listNgayLe = await fetchNgayLe({nam: moment(new Date(lsDateInMonth[0])).format('YYYYMMDD').toString().substr(0,4)})
        quanLyChiTietCongApi({
            idTeam: JSON.stringify(params.idTeam),
            tuNgay: moment(new Date(lsDateInMonth[0])).format('YYYYMMDD'),
            denNgay: moment(new Date(lsDateInMonth[lsDateInMonth.length - 1])).format('YYYYMMDD'),
            page:params.current,
            page_size:params.pageSize,
            search: params.search
        })
        .then(r=>{
            const newData = mapDataBCCDetail(r.data.results);
            // const newColumns = mapColBCCDetail(r.data.results,listNgayLe.data);
            const newColumns = mapColBCCDetail(r.data.results,listNgayLe);
            // setStatusAll(Math.min.apply(Math, r.data.filter(item=>item.statusId !== 0).map(function(o) { return o.statusId; })))
            setData(newData[0]);
            setLsMemberId(newData[1]);
            setColumns(newColumns);
            let resData = r.data.results.filter(item=>item.statusId !== 0);
            if (resData.length != 0) {
                setStatusAll(r.data.results.filter(item=>item.statusId !== 0).map(function(o) { return o.data; })[0].map(function(o) {if (o.id !== '') {return o.statusId}; }))
            } else {
                setStatusAll([0])
            }

            setPager({
                current: params.current,
                pageSize: params.pageSize,
                count: r.data.count
            });
            setLoading(false);
            // console.log(r.data);
        })
        .catch(err=>{
            errorHandle(err);
            setLoading(false);
        })
    }

    const fetchListTeam = () =>{
        ListBoPhanApi().then(res=>{
            // const lsBoPhanTeam = res.data.filter(itemBP => itemBP.team.length != 0 );
            const arrTeam = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === 'detailed_timesheet_view')
                                                    .map((item,index)=>{
                                                        const idBoPhanForTeam = res.data.filter(itemBP =>  itemBP.team.some(itemT => itemT.id==item.team) )
                                                        if (idBoPhanForTeam.length != 0){
                                                            return {idTeam:item.team, team:item.team__tenTeam, idBoPhan: idBoPhanForTeam[0].id}
                                                        }
                                                        return false
                                                    }).filter(item => item != false);
            const uniqueArrTeam = [...new Map(arrTeam.map(item =>[item['idTeam'], item])).values()];
            uniqueArrTeam.sort(function(first, second) {
                return first['idTeam'] - second['idTeam'] ;
              });
            const arrIdTeam = uniqueArrTeam.map(item=>item.idTeam);
            const arrBoPhan = res.data.filter(({team}) => team.some(item => arrIdTeam.includes(item.id)) )
            // const arrBoPhan = res.data.filter(itemBP => itemBP.team.map(item=>item.id).filter(x => arrIdTeam.includes(x)))
            if (arrBoPhan.length > 0) {
                setCurrentBoPhan([arrBoPhan[0].id]);
            }
            setLsBoPhan(arrBoPhan);

            setLsAllTeam(uniqueArrTeam);
            if (currentTeam.length === 0){
                setCurrentTeam([arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x))[0]]); // 200423 lấy element đầu tiên đặt trong list
            }
            setLsTeam(uniqueArrTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x.idTeam)) );
        });
    }

    useEffect(()=>{
        if (userInfo.team_permissions.length === 0){
            openNotificationWithIcon("error", "Bạn chưa có quyền cho team.")
        }
        if (userInfo && userInfo.team_permissions && userInfo.team_permissions.length > 0){
            fetchListTeam();
        }
    },[userInfo])

    useEffect(()=>{
        if (lsDate.length > 0 && currentTeam.length > 0) {
            fetchData({ idTeam: currentTeam, lsDate: lsDate, ...pager});
        }
        if (currentTeam.length === 0) {
            setData([])
        }
    },[lsDate,currentTeam])

    const updateData=()=>{
        fetchData({idTeam: currentTeam, lsDate: lsDate, ...pager})
    }

    const onChangeBoPhan =(value)=>{
        if (value.length > 0) {
            setCurrentBoPhan(value);
            const lsTeamWith_BP = lsAllTeam.filter(x => value.includes(x.idBoPhan))
            setLsTeam(lsTeamWith_BP);
            setCurrentTeam([lsTeamWith_BP.map(item=>item.idTeam)[0]]); //200423
        } else {
            setLsTeam([]);
            setCurrentBoPhan([]);
            setCurrentTeam([]);
        };
    }

    const tPropsConfig_BoPhan = {
        treeData:[ {
            title:
                currentBoPhan.length > 0 ? (
                <span
                  onClick={() => {if (!loading){onChangeBoPhan([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {onChangeBoPhan(lsBoPhan.map(item=>item.id))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeDataBoPhan],
        value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
        onChange:onChangeBoPhan,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
        maxTagCount:2,
        placeholder: 'Chọn bộ phận',
        style:{width:'fit-content', minWidth:200},
        disabled: loading,
      };

    useEffect(()=>{
        const treeDataBoPhan = lsBoPhan.map(item=>{return {title: item.tenBophan, value: item.id, key: item.id}})
        setTreeDataBoPhan(treeDataBoPhan);
        if (currentBoPhan.length === 0){
            setCurrentBoPhan(lsBoPhan.map(item=>item.id));
        };
    },[lsBoPhan])

    const onChangeTeam =(value)=>{
        if (value.length > 0) {
            setCurrentTeam(value);
        } else {
            setCurrentTeam([]);
        };
    }

    const tPropsConfig = {
        treeData:[{
            title:
                currentTeam.length > 0 ? (
                <span
                  onClick={() => {if (!loading){setCurrentTeam([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {setCurrentTeam(lsTeam.map(item=>item.idTeam))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeData],
        value:treeData.length > 0 ? currentTeam : undefined,
          onChange:onChangeTeam,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn team',
        style:{width:'fit-content',minWidth:200},
        disabled: loading,
      };

    useEffect(()=>{
        const treeDataTemp = lsTeam.map(item=>{return {title: item.team, value: item.idTeam, key: item.idTeam}})
        setTreeData(treeDataTemp);
        // if (currentTeam.length === 0){
        //     setCurrentTeam(lsTeam.map(item=>item.idTeam));
        // };
        // setCurrentTeam(lsTeam.map(item=>item.idTeam));

    },[lsTeam])

    const onChangeDate =(date)=>{
        setIsComboDate(true)
        setCurrentSelectedDate(date);
        const lsDateTemp = getDateRange(date);
        setLsDate(lsDateTemp);
    };

    useEffect(()=>{
        if (isComboDate){
            const arrDay = generateArrWeekAndDays(currentSelectedDate.year(), currentSelectedDate.month()+1);
            setLsAllWeek(arrDay);
            const filterWeek = arrDay.filter(item => item.days.some(date => date.isSame(currentSelectedDate, 'date')))[0]
            setCurrentWeek(filterWeek.name);
            setIdCurWeek(filterWeek.id)
        }
    },[currentSelectedDate]);

    const onQuickChangeWeek=(type)=>{
        if (loading){
            return;
        }
        setIsComboDate(false)
        if (type === 'previous'){
            var newFirstDate;
            if (idCurWeek-1 < 0){
                const lstDateMark = generateArrWeekAndDays(moment(currentSelectedDate).year(), moment(currentSelectedDate).month())
                setLsAllWeek(lstDateMark);
                setCurrentWeek(lstDateMark[lstDateMark.length - 1].name);
                setIdCurWeek(lstDateMark.length - 1)
                newFirstDate = lstDateMark[lstDateMark.length-1].days[0];
            }
            else{
                setCurrentWeek(lsAllWeek[idCurWeek-1].name);
                setIdCurWeek(idCurWeek-1)
                newFirstDate = lsAllWeek[idCurWeek-1].days[0];
            }
        }
        else {
            if(idCurWeek + 1 >= lsAllWeek.length) {
                const lstDateMark = generateArrWeekAndDays(moment(currentSelectedDate).year(), moment(currentSelectedDate).month()+2)
                setLsAllWeek(lstDateMark);
                setCurrentWeek(lstDateMark[0].name);
                setIdCurWeek(0)
                newFirstDate = lstDateMark[0].days[0];
            }else {
                setCurrentWeek(lsAllWeek[idCurWeek+1].name);
                setIdCurWeek(idCurWeek+1)
                const numberDay = lsAllWeek[idCurWeek].days.length;
                newFirstDate = new Date(new Date(lsAllWeek[idCurWeek].days[0]).getTime()+((numberDay)*24*60*60*1000));
            }
        }

        const lsDateTemp = getDateRange(moment(newFirstDate));
        setCurrentSelectedDate(moment(newFirstDate));
        setLsDate(lsDateTemp);

    }

    const onChangeSelectWeek = (value) => {
        setCurrentWeek(value)
        const lsAllWeekChange = lsAllWeek.filter(item => item.name == value);
        setCurrentSelectedDate(lsAllWeekChange[0].days[0]);
        const lsDateTemp = getDateRange(lsAllWeekChange[0].days[0]);
        setLsDate(lsDateTemp);
        setIdCurWeek (lsAllWeekChange[0].id)
    };

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        // fetchData({
        //     idTeam:JSON.stringify(currentTeam),
        //     tuNgay:moment(lsDate[0]).format("YYYYMMDD"),
        //     denNgay:moment(lsDate[6]).format("YYYYMMDD"),
        //     page_size:pagination.pageSize,
        //     page:pagination.current});
        fetchData({
            idTeam: currentTeam,
            lsDate: lsDate,
            status: currentPager.status,
            pageSize: pagination.pageSize,
            current: pagination.current,
            search
        })
    }

    // const textABC = (value) => {
    //     const lsDictA = [
    //         {id: 1, database: 1, name: '123', created_date: '2023-05-04T09:39:15.734352Z', updated_date: '2023-05-04T09:39:15.783177Z'},
    //         {id: 2, database: 1, name: '123456', created_date: '2023-05-04T09:39:15.734352Z', updated_date: '2023-05-04T09:39:15.783177Z'},
    //         {id: 3, database: 1, name: '12345678', created_date: '2023-05-04T09:52:11.180025Z', updated_date: '2023-05-04T09:52:11.180078Z'}
    //     ]
    //     const lsConvertDictA = lsDictA.slice(0).sort((a,b)=>b.created_date.localeCompare(a.created_date));
    //     console.log(lsConvertDictA);
    // };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Bảng chấm công chi tiết</h4>
                        {/* <Button type={'danger'} onClick={()=>textABC(true)}>textABC</Button> */}
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Quản lý</Link>
                                </li>
                                <li className="breadcrumb-item active">Bảng chấm công chi tiết</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                    <div className={'col'}>
                        <Space align="center" className="space-align-block styleNtn_1" >
                            <Button type="primary" className={'styleNtn_1 addBtnWeek'} onClick={()=>onQuickChangeWeek('previous')} title="Tuần trước">
                                <i className={'fa fa-arrow-left'}></i>
                            </Button>
                            <Select
                                onChange={onChangeSelectWeek}
                                value={currentWeek}
                            >
                                {lsAllWeek.map((item, key) => <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>)}
                            </Select>

                            <Button type="primary" className={'styleNtn_1 addBtnWeek'} onClick={()=>onQuickChangeWeek('next')} title="Tuần sau">
                                <i className={'fa fa-arrow-right'}></i>
                            </Button>
                        </Space>
                        <DatePicker disabled={loading} style={{borderRadius:10}} className={'m-2'} onChange={onChangeDate} value={currentSelectedDate} format={'DD/MM/YYYY'} allowClear={false}/>
                        <div className="styleBadge">
                            <Badge.Ribbon text="Bộ phận" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig_BoPhan} />
                            </Badge.Ribbon>
                        </div>
                        <div className="styleBadge">
                            <Badge.Ribbon text="Team" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig} />
                            </Badge.Ribbon>
                        </div>

                        {userInfo && userInfo.user_permissions && systemGroup && systemGroup.length > 0 && currentTeam.length > 0 && !loading && currentTeam &&
                        <GetLsButton permissions={userInfo.user_permissions} systemGroup={systemGroup} status={statusAll} lsDate={lsDate}
                            teamPermissions={userInfo.team_permissions}
                        />}
                    </div>
                    <div>
                        {/*<Button type={'primary'} style={{marginRight:10}} onClick={()=>setIsShowTongSoNgayNghiTrongThang(true)}>Tổng số ngày nghỉ trong tháng</Button>*/}
                        {/*<Button type={'danger'} onClick={()=>setIsShowChinhSuaLichLamViec(true)}>Chỉnh sửa lịch làm việc</Button>*/}
                    </div>
                </div>
            </div>

            <div className="row">
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={loading}
                    bordered={true}
                    className={'custom-table-hover style-6'}
                    scroll={data.length > 0 && {x:1920,y:500}}
                    // scroll={{x:1200}}
                    size={'small'}
                    rowKey="id"
                    onChange={handleChange}
                    pagination={{
                        current: pager.current,
                        pageSize: pager.pageSize,
                        total: pager.count,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['50','75','100']

                    }}
                    // pagination={false}
                />
            </div>
            <div style={{textAlign: "right"}}>
                <Badge>
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#ffffff", border: "1px solid gray"}} />
                    Trạng thái “Xem xét”, “Chốt công”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#4ca4f1"}} />
                    Trạng thái “Chờ NPD phê duyệt”
                </Badge>
                <Badge>
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#75ef42"}}/>
                    Trạng thái “NPD đã phê duyệt”
                </Badge>
                <Badge  >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#31ecd0"}}/>
                    Trạng thái “HR đã phê duyệt”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "red"}}/>
                    Trạng thái “NPD không phê duyệt”
                </Badge>
                <Badge >
                    <BsFillSquareFill className="styleBorder_1 timekeeper-detail-note" style={{color: "#ec238a"}}/>
                    Trạng thái “HR không phê duyệt”
                </Badge>
            </div>
            <ModalDetailItem
                visible={isShowDetailItem}
                onCancel={()=>setIsShowDetailItem(false)}
                itemDetail={currentItem}
                currentDate={currentDateSelected}
                updateData={updateData}

            />
            {/* <ModalViewHistoryEdit
                visible={isShowHistoryEdit}
                onCancel={()=>setIsShowHistoryEdit(false)}
                itemDetail={dataLichSuEdit}
                currentDate={currentDateSelected}
            /> */}
        </>
    )
}